import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
// layouts
import NonAuthLayout from "../Layout/NonAuthLayout";
import VerticalLayout from "../Layout/VerticalLayout/index";
import { AppContext } from "../components/common/Helpers/Context/AppContext";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { PatientsRoutes, authProtectedRoutes, LabRoutes, publicRoutes, PharmacistRoutes } from "./routes";
import { AuthProtected } from "./AuthProtected";
import { useNavigate } from "react-router-dom";

const Index = () => {
  const [globalData, setGlobalData] = React.useState<any>({
    loading: false,
    severity: "error",
    errorMessage: "",
    error: false,
    isLoggedIn:false
  });
  const outerTheme = createTheme({
    palette: {
      primary: {
        main: "#00a8ec",
        contrastText: "#ffffff",
      },
      secondary: {
        main: "#080606",
        contrastText: "#ffffff",
      },
      error: {
        main: "#ff3d60",
      },
      success: {
        main: "#1cbb8c",
        contrastText: "#ffffff",
      },
    },
    typography: {
      "fontFamily": `"Roboto", "Helvetica", "Arial", sans-serif`,
      "fontSize": 14,
      "fontWeightLight": 300,
      "fontWeightRegular": 400,
      "fontWeightMedium": 500
    }
  });
  const navigate = useNavigate();
  const [authRoutes, setAuthRoutes] = useState<any>([])
  // useEffect(() => {
  //   let res: any = getLocalData("loginData")
  //   console.log(res, "######")
  //   setAuthRoutes([])
  //   if (res?.role_id == 3) { setAuthRoutes(HandyManRoutes) }
  //   else if (res?.role_id == 2) { setAuthRoutes(authProtectedRoutes) }
  //   else if(res?.role_id == 4) {setAuthRoutes(LeadRoutes)}
  // }, [changeValue])

  // window.addEventListener('storage', () => {
  //   window.location.reload();
  // })

  // window.addEventListener('login', () => {
  //   setChangeValue(Math.random());
  // })

  useEffect(()=>{
    let data:any = localStorage.getItem('loginData');
    if(data){
      setGlobalData({
        ...globalData,
        data:JSON.parse(data),
        isLoggedIn:true
      })
      navigate("/");
    }else{
      navigate('login')
    }
  },[])

  useEffect(()=>{
    if(globalData.isLoggedIn){
      if (Number(globalData.data?.role_id) === 2) { setAuthRoutes(PatientsRoutes) }
      else if (Number(globalData.data?.role_id) === 1) { setAuthRoutes(authProtectedRoutes) }
      else if(Number(globalData.data?.role_id) === 3) {setAuthRoutes(LabRoutes)}
      else if(Number(globalData.data?.role_id) === 4) {setAuthRoutes(PharmacistRoutes)}
    }
     
  },[globalData]);

  return (
    <ThemeProvider theme={outerTheme}>
      <React.Fragment>
        <AppContext.Provider value={{ globalData, setGlobalData }}>
          <Routes>
            <Route>
              {publicRoutes.map((route: any, idx:any) => (
                <Route
                  path={route.path}
                  element={
                    <NonAuthLayout>
                      {route.component}
                    </NonAuthLayout>
                  }
                  key={idx}
                />
              ))}
            </Route>
            <Route>
              {authRoutes.map((route: any, idx: any) => (
                <Route
                  path={route.path}
                  element={
                    <AuthProtected>
                      <VerticalLayout>{route.component}</VerticalLayout>
                    </AuthProtected>
                  }
                  key={idx}
                />
              ))}
            </Route>
            <Route path="*" element={<Navigate to={globalData.isLoggedIn?"/":"/login"} />} />
          </Routes>
        </AppContext.Provider>
      </React.Fragment>
    </ThemeProvider>
  );
};

export default Index;
